// extracted by mini-css-extract-plugin
module.exports = {"container":"PackageDescription_container__1iBeR","title":"PackageDescription_title__2XCWI","list":"PackageDescription_list__2QniU"};